export const ru = {
    seconds: 'сек'
};
